import { render, staticRenderFns } from "./active-update.vue?vue&type=template&id=6f987b34&scoped=true&"
import script from "./active-update.vue?vue&type=script&lang=js&"
export * from "./active-update.vue?vue&type=script&lang=js&"
import style0 from "./active-update.vue?vue&type=style&index=0&id=6f987b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f987b34",
  null
  
)

export default component.exports